import { observable, action } from 'mobx'
import { ICourseArrItem } from '@services/api/CourseDetail/interface'

export interface ITrainingCourse {
  courseInfo: Record<any, any>
  courseFileArr: ICourseArrItem[]
  shouldRemind: boolean
  fromCloud: boolean
  changeShouldRemind(shouldRemind: boolean): void
  changeFromCloud(shouldRemind: boolean): void
  changeCourseInfo(courseInfo: Record<any, any>): void
  setCourseFileArr(courseFileArr: ICourseArrItem[]): void
}

class TrainingCourse implements ITrainingCourse {
  @observable public shouldRemind = false
  @observable public fromCloud = false
  @observable public courseInfo = {}
  @observable public courseFileArr = [] as ICourseArrItem[]

  @action
  public changeCourseInfo = (courseInfo: Record<any, any>) => {
    this.courseInfo = courseInfo
  }

  @action
  public changeFromCloud = (fromCloud: boolean) => {
    this.fromCloud = fromCloud
  }

  @action
  public changeShouldRemind = (shouldRemind: boolean) => {
    this.shouldRemind = shouldRemind
  }

  @action
  public setCourseFileArr = (courseFileArr: ICourseArrItem[]) => {
    this.courseFileArr = courseFileArr
  }
}

export default new TrainingCourse()
